


import React, { FunctionComponent, useContext, useEffect, useState } from 'react';
import { Box, Breadcrumbs, Button, Dialog, Link, Theme, Toolbar, Typography } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { useDispatch } from 'react-redux';
import { Link as RouteLink, useHistory } from 'react-router-dom';

import { getAccountAction, useAccount, } from '@ivymobi/orbit-core/business/tenant';
import { getStatsAction } from '@ivymobi/orbit-core/business/stats';
import { Tenant } from '@ivymobi/orbit-core';
import QuickStart from '../dashboard/quickStart';
import Title from '../components/views/title';
import MenuItem from '../components/views/menuItem';
import { DeviceType, WebSiteContext } from '../orbit-context';
import { getIdentification, getTitle } from './mapping';
import { SampleDialog } from '../components';

const useStyles = makeStyles((theme: Theme) => createStyles({
  pages: {

    display: 'flex',
    "@media (min-width: 768px)": {
      flexDirection:'row',
     },
     "@media (max-width: 768px)": {
      flexDirection:'column',
      padding: theme.spacing(2, 2, 0, 2)
     },
  },
  image:{
    "@media (min-width: 768px)": {
      width:'50vw',
      height:'50vw',
      maxHeight:'70vh'
     },
     "@media (max-width: 768px)": {
      width:'100%'
     },
    paddingTop:'20px',objectFit:'contain'
  },
  sliderBar:{
    "@media (max-width: 768px)": {
     order:1,
     width:'100%',
    },
    "@media (min-width: 768px)": {
      width:'25%',
     },
    display: 'flex',
    flexDirection:'column',
   
    height:'100%',
    paddingTop:theme.spacing(6),
    paddingBottom:theme.spacing(2)
  },
  content:{
    flexGrow:1,
    flexBasis:0,
    display:'flex',
    justifyContent:'center',
    alignItems:'center',
    flexDirection:'column',

    paddingTop:theme.spacing(0),
    paddingBottom:theme.spacing(2)  },


}));
export const RobotDashboardView = (props) => {
  const classes = useStyles();
  const history = useHistory();
  const deviceType = useContext(DeviceType)
  const webInfo = useContext(WebSiteContext);
  const urlParams = new URL(window.location.href);
  const [open,setOpen] = useState(false)
  const pathname = urlParams?.pathname;
  let title = getTitle(pathname)
  useEffect(()=>{
    props.setTitle(title)
    props.setParents([])
  },[])
  
  return (
    <div>
     {deviceType==='computer'&&<Breadcrumbs separator=">" maxItems={3}>
        <Link
        //   key={b.id}
          color='textPrimary'
          to={'/'}
          component={RouteLink}
        >
          首页
        </Link>
        <Typography color="textPrimary">
          {title}
        </Typography>
      </Breadcrumbs>}
      <SampleDialog open={open}
        toggle={() => {setOpen(false)}}
        maxWidth='md'
        title="上传"
      >
        <Box style={{display:'flex',alignItems:'center',justifyContent:'center'}}><p>请使用电脑浏览器打开产品选型</p></Box>
        <Toolbar style={{
        marginTop: '10px',  
        justifyContent: 'center'
      }} >

        <Button    style={{paddingTop:'3px', paddingBottom:'3px', backgroundColor:'#005AE7', color:'white', borderRadius:'4px'}} onClick={() => {
         setOpen(false)
        } }>{'关闭'}</Button>

      </Toolbar>
      </SampleDialog>
      <Box className={classes.pages} >
        {getIdentification(pathname)==='robot'&&<Box className={classes.sliderBar}>
          <Title name={title}></Title>
          <Box style={{width:'100%', height:'3px', background:'red', marginTop:'20px'}}></Box>
          <MenuItem name={'产品中心'} onClick={() => {
            history.push(pathname+'/product?catalogType='+getIdentification(pathname) );
          }}></MenuItem>
          <MenuItem name={'产品选型'} onClick={() => {
           
            history.push(pathname+'/selections?catalogType='+getIdentification(pathname));
          }}></MenuItem>
          <MenuItem name={'产品计算'} onClick={() => {
            history.push(pathname+'/calculator?catalogType='+getIdentification(pathname));
          }}></MenuItem>
          <MenuItem name={'智能化功能'} onClick={() => {
            history.push(pathname+'/intelligent?catalogType='+getIdentification(pathname));
          }}></MenuItem>
          <MenuItem name={'行业应用案例'} onClick={() => {
            history.push(pathname+'/appcase?catalogType='+getIdentification(pathname));
          }}></MenuItem>
          <MenuItem name={'资料下载'} onClick={() => {
            history.push(pathname+'/outlibs?catalogType='+getIdentification(pathname));
          }}></MenuItem>

        </Box>}
        {getIdentification(pathname)==='inv'&&<Box className={classes.sliderBar}>
          <Title name={title}></Title>
          <Box style={{width:'100%', height:'3px', background:'red', marginTop:'20px'}}></Box>
          <MenuItem name={'产品中心'} onClick={() => {
            history.push(pathname+'/product?catalogType='+getIdentification(pathname) );
          }}></MenuItem>
          <MenuItem name={'产品选型'} onClick={() => {
             if(deviceType==='mobile'){
              setOpen(true)
              return;
            }
            history.push(pathname+'/selections?catalogType='+getIdentification(pathname));
          }}></MenuItem>
          <MenuItem name={'功能特性'} onClick={() => {
            history.push(pathname+'/functional?catalogType='+getIdentification(pathname));
          }}></MenuItem>

          <MenuItem name={'行业应用'} onClick={() => {
            history.push(pathname+'/industrial?catalogType='+getIdentification(pathname));
          }}></MenuItem>
          <MenuItem name={'资料下载'} onClick={() => {
            history.push(pathname+'/outlibs?catalogType='+getIdentification(pathname));
          }}></MenuItem>

        </Box>}
        {getIdentification(pathname)==='sv'&&<Box className={classes.sliderBar}>
          <Title name={title}></Title>
          <Box style={{width:'100%', height:'3px', background:'red', marginTop:'20px'}}></Box>
          <MenuItem name={'产品中心'} onClick={() => {
            history.push(pathname+'/product?catalogType='+getIdentification(pathname) );
          }}></MenuItem>
          <MenuItem name={'产品选型'} onClick={() => {
             if(deviceType==='mobile'){
              setOpen(true)
              return;
            }
            history.push(pathname+'/selections?catalogType='+getIdentification(pathname));
          }}></MenuItem>

          <MenuItem name={'解决方案'} onClick={() => {
            history.push(pathname+'/solution');
          }}></MenuItem>
          <MenuItem name={'资料下载'} onClick={() => {
            history.push(pathname+'/outlibs?catalogType='+getIdentification(pathname));
          }}></MenuItem>

        </Box>}
        {getIdentification(pathname)==='lv'&&<Box className={classes.sliderBar}>
          <Title name={title}></Title>
          <Box style={{width:'100%', height:'3px', background:'red', marginTop:'20px'}}></Box>
          <MenuItem name={'产品中心'} onClick={() => {
            history.push(pathname+'/product?catalogType='+getIdentification(pathname) );
          }}></MenuItem>
          <MenuItem name={'资料下载'} onClick={() => {
            history.push(pathname+'/outlibs?catalogType='+getIdentification(pathname));
          }}></MenuItem>

        </Box>}
        {getIdentification(pathname)==='plc'&&<Box className={classes.sliderBar}>
          <Title name={title}></Title>
          <Box style={{width:'100%', height:'3px', background:'red', marginTop:'20px'}}></Box>
          <MenuItem name={'产品中心'} onClick={() => {
            history.push(pathname+'/product?catalogType='+getIdentification(pathname) );
          }}></MenuItem>
           <MenuItem name={'产品选型'} onClick={() => {
             if(deviceType==='mobile'){
              setOpen(true)
              return;
            }
            history.push(pathname+'/selections?catalogType='+getIdentification(pathname));
          }}></MenuItem>
          <MenuItem name={'资料下载'} onClick={() => {
            history.push(pathname+'/outlibs?catalogType='+getIdentification(pathname));
          }}></MenuItem>

        </Box>}
        {getIdentification(pathname)==='got'&&<Box className={classes.sliderBar}>
          <Title name={title}></Title>
          <Box style={{width:'100%', height:'3px', background:'red', marginTop:'20px'}}></Box>
          <MenuItem name={'产品中心'} onClick={() => {
            history.push(pathname+'/product?catalogType='+getIdentification(pathname) );
          }}></MenuItem>
          <MenuItem name={'产品选型'} onClick={() => {
                      if(deviceType==='mobile'){
                        setOpen(true)
                        return;
                      }
                      history.push(pathname+'/selections?catalogType='+getIdentification(pathname));
          }}></MenuItem>
          {/* <MenuItem name={'特性体验'} onClick={() => {
            history.push(pathname+'/functional?catalogType='+getIdentification(pathname));
          }}></MenuItem> */}
          <MenuItem name={'资料下载'} onClick={() => {
            history.push(pathname+'/outlibs?catalogType='+getIdentification(pathname));
          }}></MenuItem>

        </Box>}
        {getIdentification(pathname)==='edm'&&<Box className={classes.sliderBar}>
          <Title name={title}></Title>
          <Box style={{width:'100%', height:'3px', background:'red', marginTop:'20px'}}></Box>
          <MenuItem name={'产品中心'} onClick={() => {
            history.push(pathname+'/product?catalogType='+getIdentification(pathname) );
          }}></MenuItem>
          <MenuItem name={'资料下载'} onClick={() => {
            history.push(pathname+'/outlibs?catalogType='+getIdentification(pathname));
          }}></MenuItem>
           <MenuItem name={'操作维护'} onClick={() => {
            history.push(pathname+'/functional?catalogType='+getIdentification(pathname));
          }}></MenuItem>
          <MenuItem name={'功能介绍'} onClick={() => {
            history.push(pathname+'/functionintrol?catalogType='+getIdentification(pathname));
          }}></MenuItem>
         <MenuItem name={'加工应用'} onClick={() => {
            history.push(pathname+'/processing?catalogType='+getIdentification(pathname));
          }}></MenuItem>

        </Box>}
        {getIdentification(pathname)==='lm'&&<Box className={classes.sliderBar}>
          <Title name={title}></Title>
          <Box style={{width:'100%', height:'3px', background:'red', marginTop:'20px'}}></Box>
          <MenuItem name={'产品中心'} onClick={() => {
            history.push(pathname+'/product?catalogType='+getIdentification(pathname) );
          }}></MenuItem>
          <MenuItem name={'资料下载'} onClick={() => {
            history.push(pathname+'/outlibs?catalogType='+getIdentification(pathname));
          }}></MenuItem>
          <MenuItem name={'操作维护'} onClick={() => {
            history.push(pathname+'/functional?catalogType='+getIdentification(pathname));
          }}></MenuItem>
          <MenuItem name={'功能介绍'} onClick={() => {
            history.push(pathname+'/functionintrol?catalogType='+getIdentification(pathname));
          }}></MenuItem>
         <MenuItem name={'加工应用'} onClick={() => {
            history.push(pathname+'/processing?catalogType='+getIdentification(pathname));
          }}></MenuItem>

        </Box>}
        <Box className={classes.content}>
          <img  src={'images'+pathname+'.png'} className={classes.image}/>
          {deviceType==='computer'&&getIdentification(pathname)==='robot'&&<Typography style={{color:'black', fontSize:'66px', fontWeight:'300'}}> 
          生产力的好帮手
          </Typography>}
        </Box>
      </Box>
    </div>
  );
};

export default function RobotDashboardContainer ({setParents,setTitle}) {
  const dispatch = useDispatch();


  return ( 
    <RobotDashboardView setParents={setParents} setTitle={setTitle}

    />
  );
}